import { render } from "./UpgradeBanner.vue?vue&type=template&id=2e85ce5e"
import script from "./UpgradeBanner.vue?vue&type=script&lang=js"
export * from "./UpgradeBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__